/**
 * Formats HH:MM:SS duration into HHh MMm SSs.
 * @param {string | null | undefined} duration - Duration in HH:MM:SS format.
 * @param {string} [defaultValue] - Default value for invalid duration.
 * @returns {string} Formatted duration.
 */
function FormatTimeDuration(
  duration: string | null | undefined,
  defaultValue: string = 'N/A',
): string {
  if (!duration) {
    return defaultValue;
  }

  const parts = duration.split(':');

  if (parts.length !== 3) {
    return defaultValue;
  }

  const [hours, minutes, seconds] = parts.map(Number);

  if (
    !Number.isInteger(hours) ||
    !Number.isInteger(minutes) ||
    !Number.isInteger(seconds) ||
    hours < 0 ||
    minutes < 0 ||
    minutes > 59 ||
    seconds < 0 ||
    seconds > 59
  ) {
    return defaultValue;
  }

  return `${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`;
}

export default FormatTimeDuration;
